<template>
  <div
    class="tab-pane"
    :class="{ active: activeTab === value }"
    @click="clickHandle"
  >
    {{ title }}
  </div>
</template>
<script>
export default {
  props: {
    activeTab: {
      type: Number,
      default: 1,
    },
    value: {
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      default: "",
    },
  },
  methods: {
    clickHandle() {
      this.$emit("change", this.value);
    },
  },
};
</script>
<style lang="less">
.tab-pane {
  height: 30px;
  line-height: 30px;
  padding: 0 25px;
  border-radius: 30px;
  color: @text-color-base;
  text-align: center;
  margin-right: 15px;
  cursor: pointer;

  &.active {
    background-color: @main-color;
    color: #ffffff;
  }
}
</style>